import { fetchMyEvents, fetchPackages, fetchProducts, saveEvent } from "../lib/api.js";
import { signOut } from "../lib/auth.js";
import { formatDate } from "../lib/format.js";
import { escapeHtml, showError } from "../lib/ui.js";
import { eventFormHtml, wireEventForm } from "./eventForm.js";

/**
 * Única pantalla del rol empleado: cargar un evento nuevo o corregir uno propio.
 *
 * No aparece ni un importe: ni tarifas, ni ingreso, ni costos. El empleado
 * declara qué se usó y cuántos chicos hubo; la familia le pone los números
 * después. Y esto no depende de esta vista — las tablas con plata no tienen
 * ninguna política RLS para el rol empleado, así que aunque alguien mirara las
 * peticiones a mano, no obtendría una sola fila.
 */
export async function renderEmployeeEvent(container, profile, onSignOut) {
  container.innerHTML = `<div class="employee-screen"><p>Cargando…</p></div>`;

  try {
    const [products, packages, myEvents] = await Promise.all([
      fetchProducts(),
      fetchPackages(),
      fetchMyEvents(),
    ]);
    let editing = null;

    const draw = () => {
      container.innerHTML = `
        <div class="mobile-topbar">
          <h1>Grow Up</h1>
          <button id="signout">Salir</button>
        </div>
        <div class="employee-screen">
          <h2>${editing ? "Corregir evento" : "Cargar evento"}</h2>
          <p style="color: var(--text-muted)">
            Hola ${escapeHtml(profile.name)}, acá cargás un evento nuevo o corregís uno que hayas
            cargado vos. Los números los completa la familia.
          </p>

          ${
            myEvents.length > 0
              ? `<div class="panel">
                  <h3>Mis eventos</h3>
                  <div class="event-select-list">
                    ${myEvents
                      .map(
                        (e) => `<button type="button" data-edit="${escapeHtml(e.id)}">
                          <strong>${escapeHtml(e.description)}</strong><br />
                          <span style="color: var(--text-muted); font-size: 13px">${formatDate(e.date)} · ${e.children_count} chicos</span>
                        </button>`
                      )
                      .join("")}
                  </div>
                  ${editing ? `<button class="btn secondary" id="new-instead">Cargar uno nuevo en su lugar</button>` : ""}
                </div>`
              : ""
          }

          <div class="panel">
            ${eventFormHtml({ products, packages, event: editing, includeFinance: false })}
          </div>
        </div>
      `;

      container.querySelector("#signout").addEventListener("click", async () => {
        await signOut();
        onSignOut();
      });

      container.querySelectorAll("[data-edit]").forEach((btn) =>
        btn.addEventListener("click", () => {
          editing = myEvents.find((e) => e.id === btn.dataset.edit);
          draw();
        })
      );

      container.querySelector("#new-instead")?.addEventListener("click", () => {
        editing = null;
        draw();
      });

      wireEventForm(container, {
        products,
        packages,
        event: editing,
        includeFinance: false,
        onCancel: () => {
          editing = null;
          draw();
        },
        onSubmit: async ({ operational }) => {
          await saveEvent(operational, editing?.id ?? null);
          window.alert(editing ? "Evento actualizado." : "Evento guardado.");
          renderEmployeeEvent(container, profile, onSignOut);
        },
      });
    };

    draw();
  } catch (error) {
    showError(container, error);
  }
}
